import React, { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import InlineDialog from '@atlaskit/inline-dialog';

import { DetailedBranchPullRequest } from '../../types';
import PullRequestShortRow from '../pull-request-short-row';

import i18n from './pull-request-list-dialog.i18n';
import * as styles from './pull-request-list-dialog.styled';

type Props = {
  pullRequests: DetailedBranchPullRequest[];
};

type State = {
  isOpen: boolean;
};

class PullRequestListDialog extends PureComponent<Props, State> {
  state = {
    isOpen: false,
  };

  handleToggle = () =>
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  handleClose = () => this.setState({ isOpen: false });

  render() {
    const { pullRequests } = this.props;
    const { isOpen } = this.state;

    const content = (
      <styles.PullRequestDialogContent>
        {pullRequests.map(pullRequest => (
          <styles.PullRequestDialogRow key={pullRequest.id}>
            <PullRequestShortRow pullRequest={pullRequest} />
          </styles.PullRequestDialogRow>
        ))}
      </styles.PullRequestDialogContent>
    );

    return (
      <InlineDialog
        onClose={this.handleClose}
        content={content}
        isOpen={isOpen}
        placement="left"
      >
        <CustomThemeButton onClick={this.handleToggle} appearance="link">
          <FormattedMessage
            {...i18n.triggerButtonText}
            values={{ count: pullRequests.length }}
          />
        </CustomThemeButton>
      </InlineDialog>
    );
  }
}

export default PullRequestListDialog;
